import React from 'react';
import { CurvedArrow } from '../../../icons/Icons';
import styled from 'styled-components';
import { P, Bold } from '../../../components/Typography/Typography';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { media } from '../../../components/style-utils';
import { Colors } from '@Constants';

export default function Video(props) {
  return (
    <Container>
      <TextBox>
        <Ready>
          <Bold>Ready to get started? Here are your first three steps:</Bold>
        </Ready>
        <Steps>
          <StepItem>
            Fill out your intake survey:{' '}
            <A target="_blank" href="https://prochur.ch/2zReDkI">
              click here
            </A>
          </StepItem>
          <StepItem>
            Join The 167 Insiders Group:{' '}
            <A target="_blank" href="https://www.facebook.com/groups/the167insiders/">
              click here
            </A>
          </StepItem>
          <StepItem>
            Ready to start mentorship? Send us your first email to{' '}
            <A href="mailto:mentor@prochurchtools.com">mentor@prochurchtools.com</A>.
          </StepItem>
        </Steps>
        <CTA>
          And watch this 2-minute welcome video!
          <StyledArrow />
        </CTA>
      </TextBox>

      <StyledVideoPlayer url="https://home.wistia.com/medias/wqbm46rjp5" />
    </Container>
  );
}

const Container = styled(P)`
  padding: 0 3rem 5rem;
  position: relative;
  z-index: 100;
`;

const StyledVideoPlayer = styled(VideoPlayer)`
  max-width: 110rem;
  margin-left: auto;
  margin-right: auto;

  box-shadow: 0 0.2rem 8rem 0 rgba(13, 189, 227, 0.2);

  & > div {
    background: ${Colors.PrimaryLight};
    border-radius: 0.6rem;

    ${media.tabletLandscapeAndUp`
      border-radius: 1.7rem;
    `}
  }
`;

const TextBox = styled.div`
  max-width: 85rem;
  margin-left: auto;
  margin-right: auto;
`;

const Ready = styled(P)`
  margin: 0;
`;

const Steps = styled.ol`
  padding-left: 4.5rem;
  margin: 0;
  /* list-style-position: inside; */
`;

const StepItem = styled.li`
  margin-bottom: 3rem;
`;

const CTA = styled.p`
  position: relative;
  display: inline-block;
`;

const A = styled.a`
  text-decoration: underline;
  color: currentColor;
  :visited {
    color: currentColor;
  }
`;

const StyledArrow = styled(CurvedArrow)`
  display: none;

  position: absolute;
  bottom: 0;
  right: 0;

  transform: translate(100%, 100%);

  color: var(--colorPrimaryMedium);
  width: 7.5rem;
`;



// WEBPACK FOOTER //
// ./src/routes/ThankYou/components/Video.js